import React from 'react';
import { Render } from '@puckeditor/core';
import { puckContentConfig } from '../puck/puckContentConfig';
import { themeElementBlocks } from './elementPreviewBlocks';
import SitePreviewScope from './SitePreviewScope';

/**
 * Un élément du site (tableau, carte info, volet) rendu avec un style de
 * `configuration` — celle du document ou celle du thème du site.
 */
export default function ElementStylePreview({
  kind, styleId, configuration, theme,
}) {
  return (
    <SitePreviewScope configuration={configuration} theme={theme}>
      <Render
        config={puckContentConfig}
        data={{ root: { props: {} }, content: themeElementBlocks(kind, styleId, configuration) }}
        metadata={{ themeConfiguration: configuration }}
      />
    </SitePreviewScope>
  );
}
